// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__aWKtI"};